import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'element-closest-polyfill'
import 'whatwg-fetch'
import './WeakRef.js'
